import { useState } from "react";
import { Field, Select } from "./ui";

/** Canada's provinces and territories (stored as the 2-letter code). */
export const PROVINCES: Record<string, string> = {
  ON: "Ontario", QC: "Quebec", BC: "British Columbia", AB: "Alberta", MB: "Manitoba", SK: "Saskatchewan", NS: "Nova Scotia",
  NB: "New Brunswick", NL: "Newfoundland and Labrador", PE: "Prince Edward Island", YT: "Yukon", NT: "Northwest Territories", NU: "Nunavut",
};
const OUT = "__out";

/** Province dropdown; "Outside Canada" opens a country and a state / region box. */
export function ProvinceField({ province, country, onChange }: { province: string | null | undefined; country?: string | null; onChange: (province: string | null, country: string | null) => void }) {
  const known = !!province && province.toUpperCase() in PROVINCES;
  const [outside, setOutside] = useState(!!province && !known || (!!country && !/^canada$/i.test(country)));
  return <>
    <Field label="Province">
      <Select value={outside ? OUT : known ? province!.toUpperCase() : ""} placeholder="Choose…"
        options={[...Object.entries(PROVINCES).map(([v, l]) => ({ value: v, label: `${l} (${v})` })), { value: OUT, label: "Outside Canada…" }]}
        onChange={(v) => { if (v === OUT) { setOutside(true); onChange(null, country && !/^canada$/i.test(country) ? country : null); } else { setOutside(false); onChange(v || null, v ? "Canada" : country ?? null); } }} />
    </Field>
    {outside && <>
      <Field label="Country"><input className="input" value={country ?? ""} placeholder="e.g. United States, Nigeria" onChange={(e) => onChange(province ?? null, e.target.value || null)} /></Field>
      <Field label="State / region"><input className="input" value={province ?? ""} onChange={(e) => onChange(e.target.value || null, country ?? null)} /></Field>
    </>}
  </>;
}
